<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="d-flex align-center justify-space-between">
        <h2>Visite mediche</h2>

      </v-col>
      <v-col cols="12">
        <v-divider />
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="2">
            <v-text-field  v-model="query.fullname" label="Nome"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="2">
            <v-text-field  v-model="query.email" label="Email" ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="2">
            <v-select  v-model="query.certexp" label="Scadenza certificato" clearable :items="[{title:'Cert. scaduto',value:'true'},{title:'Cert. valido',value:'false'}]"></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="2">
            <v-switch v-model="query.active" label="Filtro magico*" hint="*filtra per utenti con abbonamenti attivi" persistent-hint></v-switch>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <data-table :headers="headers" collection="users" :editable="false" :deletable="false" :query="query" @error="onListError" :default-limit="50" session-key="mediche">
          <template v-slot:item.surname="{ item }">
            <a @click="$router.push(`/users/${item._id}`)" ><b>{{ item.surname }}</b>, {{item.name}}</a>
          </template>
          <template v-slot:item.date_of_birth="{ item }">
            {{ calcAge(item.date_of_birth) }}
          </template>
          <template v-slot:item.certificate="{ item }">
            <strong v-if="item.certificate" class="text-success">Accettato</strong>
            <strong v-else class="text-error">Non accettato</strong>
          </template>
          <template v-slot:item.medical_cert="{ item }">
            <a v-if="item.medical_cert" class="text-decoration-underline" @click="downloadMedicalCert(item._id)"><strong class="text-success">Sì</strong></a>
            <strong v-else class="text-error">No</strong>
          </template>
          <template v-slot:item.medical_cert_expiration="{ item }">
            <span v-if="item.medical_cert_expiration">{{ formatDate(item.medical_cert_expiration) }}</span>
            <span v-else>-</span>
          </template>

        </data-table>

      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import config from "../config";
import utils from '../utils'
import DataTable from "@/components/DataTable.vue";
import {inject, ref} from "vue";
import type {Auth} from "@/plugins/auth.js";
import {type Messages, Msg} from "@/plugins/messages.js";
import {useRouter} from "vue-router";
import type {DataTableError, Query} from "@/models.js";
export default {
  name: "UserList",
  components: {DataTable},
  setup() {
    const auth = inject('auth') as Auth
    const messages = inject('messages') as Messages
    const router = useRouter()

    const query = ref<Query>({
      role : 'user',
      active : true
    })
    // Methods
    const calcAge = (birth: string) => {
      const age = utils.calcAge(birth)
      return age + " anni"
    }
    return {
      query,
      calcAge,
      certExpSearch : null,
      activeUserSearch : true,
      headers : [
        { title : 'Cognome e nome', sortable: true, align: 'left', value : 'surname' },
        { title : 'Email', sortable: true, align: 'left', value : 'email' },
        { title : 'Telefono', sortable: true, align: 'left', value : 'phone' },
        { title : 'Età', sortable: false, align: 'left', value : 'date_of_birth' },
        { title : 'Accettazione responsabilità', sortable: true, align: 'center', value : 'certificate', width : 60 },
        { title : 'Certificato', sortable: true, align: 'center', value : 'medical_cert', width : 60 },
        { title : 'Scadenza', sortable: true, align: 'center', value : 'medical_cert_expiration'},
      ],
      onListError(e:DataTableError) {
        if(e.status === 401) {
          messages.error(Msg.permissionError)
          auth.logout()
          return
        }
        messages.error(`Errore: ${e.message}`)
      },
      formatDate : utils.formatDate,
      downloadMedicalCert(id:string) {
        window.open(`${config.apiServer}/api/users/${id}/medical?t=${localStorage.token}`)
      },
    }
  }
}
</script>

<style scoped>

</style>